(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-ng-demo]').forEach(function (demo) {
      if (demo.dataset.ngReady) return;
      demo.dataset.ngReady = 'true';
      var radios = Array.prototype.slice.call(demo.querySelectorAll('[data-ng-pattern]'));
      var images = Array.prototype.slice.call(demo.querySelectorAll('[data-ng-demo-image]'));
      var brightness = demo.querySelector('[data-ng-brightness]');
      function select(radio) {
        images.forEach(function (image) { image.hidden = image.dataset.ngDemoImage !== radio.value; });
        demo.querySelector('[data-ng-demo-name]').textContent = radio.dataset.ngPatternName;
        demo.querySelector('[data-ng-demo-tag]').textContent = radio.dataset.ngPatternName;
        demo.querySelector('[data-ng-demo-count]').textContent = radio.dataset.ngPatternNumber.padStart(2, '0');
      }
      function setBrightness() {
        var level = Math.max(1, Math.min(5, Number(brightness.value) || 4));
        var percent = level * 20;
        demo.querySelector('[data-ng-demo-images]').style.filter = 'brightness(' + (0.36 + level * 0.16) + ')';
        brightness.style.setProperty('--ng-range-fill', ((level - 1) * 25) + '%');
        brightness.setAttribute('aria-valuetext', percent + ' percent');
        demo.querySelector('[data-ng-brightness-label]').textContent = percent + '%';
      }
      radios.forEach(function (radio) { radio.addEventListener('change', function () { if (radio.checked) select(radio); }); });
      if (brightness) { brightness.addEventListener('input', setBrightness); setBrightness(); }
      var selected = radios.find(function (radio) { return radio.checked; });
      if (selected) select(selected);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
